import PropTypes from 'prop-types'
import React, { useState, useEffect, useMemo, useRef } from 'react'

import { Button } from '@/components/Button'
import { Form, FormTextField, FormCheckbox } from '@/components/CoForm'
import { Yup as y } from '@/services/yup'
import { Box } from '@material-ui/core'

import {
  StyledDialog,
  StyledDialogActions,
  StyledDialogContent,
  StyledDialogTitle,
} from '@/components/Dialog/styles'

import { unmask } from '@/services/masks'
import * as regexp from '@/consts/regexp'
import { ComboboxTruckTypes } from '@/components/Combobox'

const VehicleFormSchema = y.object({
  wev_placa: y.string().required().trim().min(7, 'Informe a placa'),
  id_tipo_caminhao: y.number().required('Informe o tipo do caminhão'),
  wev_ativo: y.boolean(),
})

export function VehicleFormEdit(props) {
  const { current, open, onClose, onSave } = props

  const [isSubmitting, setIsSubmitting] = useState(false)

  const formRef = useRef(null)

  const defaultValues = useMemo(() => {
    return {
      wev_placa: current?.wev_placa || '',
      wev_ativo: current?.wev_ativo ?? true,
      id_tipo_caminhao: current?.id_tipo_caminhao || 0,
    }
  }, [current])

  useEffect(() => {
    if (formRef.current) {
      formRef.current.setData(defaultValues)
    }
  }, [defaultValues])

  async function handleSubmit(data) {
    const { wev_placa, wev_ativo, id_tipo_caminhao } = data

    setIsSubmitting(true)

    await onSave({
      wev_ativo,
      id_tipo_caminhao,
      wev_placa: unmask(wev_placa),
    })

    setIsSubmitting(false)
  }

  return (
    <StyledDialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <Form
        onSubmit={handleSubmit}
        formRef={formRef}
        initialData={defaultValues}
        schema={VehicleFormSchema}
      >
        {current && (
          <StyledDialogTitle>
            {current.id ? 'Editar caminhão' : 'Adicionar caminhão'}
          </StyledDialogTitle>
        )}

        {!current && <StyledDialogTitle>...</StyledDialogTitle>}

        <StyledDialogContent>
          <Box mt={2} display="flex" flexDirection="column" gridGap="1rem">
            <FormTextField
              fullWidth
              name="wev_placa"
              label="Placa"
              type="text"
              variant="standard"
              placeholder=""
              required
              textMaskProps={{ mask: regexp.placa.array }}
            />

            <ComboboxTruckTypes
              fullWidth
              name="id_tipo_caminhao"
              label="Tipo do Caminhão"
              variant="standard"
              placeholder=""
            />

            <Box>
              <FormCheckbox name="wev_ativo" label="Ativo" />
            </Box>
          </Box>
        </StyledDialogContent>

        <StyledDialogActions>
          <Button variant="outlined" color="primary" onClick={onClose}>
            Cancelar
          </Button>

          <Button
            loading={isSubmitting}
            type="submit"
            variant="contained"
            color="primary"
          >
            Salvar
          </Button>
        </StyledDialogActions>
      </Form>
    </StyledDialog>
  )
}

VehicleFormEdit.propTypes = {
  current: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
}
